module.exports = __webpack_public_path__ + "skins/MacOSXAqua1-5-88dbd4e043795c98625462a908a2d965.wsz";


//////////////////
// WEBPACK FOOTER
// ./skins/MacOSXAqua1-5.wsz
// module id = 133
// module chunks = 5